import React from 'react';

const JoinDotsIcon: React.FC<{ fill: string }> = ({ fill = '#ffffff' }) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    width="20.46"
    height="11.9"
    viewBox="0 0 20.46 11.9"
  >
    <g id="Layer_1-2" data-name="Layer 1">
      <g>
        <path
          fill={fill}
          d="M2.06,7.18c-2.86.12-2.68,4.57.19,4.45,2.86-.12,2.68-4.57-.19-4.45Z"
        />
        <path
          fill={fill}
          d="M10.31,0c-2.86.12-2.68,4.57.19,4.45C13.36,4.33,13.18-.12,10.31,0Z"
        />
        <path
          fill={fill}
          d="M18.21,7.45c-2.86.12-2.68,4.57.19,4.45,2.86-.12,2.68-4.57-.19-4.45Z"
        />
        <path
          fill={fill}
          d="M3.93,7.29l.66.59c.39-.44.79-.87,1.2-1.29l-.64-.62c-.42.43-.82.87-1.22,1.32Z"
        />
        <path
          fill={fill}
          d="M6.42,4.7l.62.64c.42-.41.86-.81,1.3-1.2l-.59-.66c-.45.4-.89.81-1.32,1.22Z"
        />
        <rect
          fill={fill}
          x="12.67"
          y="3.79"
          width=".89"
          height="1.78"
          transform="translate(.63 10.84) rotate(-45.9)"
        />
        <rect
          fill={fill}
          x="15.23"
          y="6.27"
          width=".89"
          height="1.78"
          transform="translate(-.37 13.44) rotate(-45.92)"
        />
      </g>
    </g>
  </svg>
);

export default JoinDotsIcon;
